// const player = document.querySelector(".nr_cart_progress_checkmark");
// player.load("https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Animation_-_1709712761018.json?v=1709713283");

$(document).on("mouseover", ".nr_cart_item_remove", function () {
  $(this).addClass("active");
});
$(document).on("mouseleave", ".nr_cart_item_remove", function () {
  $(this).removeClass("active");
});

function freeGiftFromOffer() {
  jQuery.getJSON("/cart.js", function (cart) {
    console.log(cart);
    if (cart.item_count >= 1) {
      var giftId = 49088864321859;
      var giftQty = 0;

      var bookGiftId = 48896797671747;
      var bookGiftQty = 0;

      var bookId = 48799612797251;
      var bookQty = 0;

      var callId = 48373983019331;
      var callQty = 0;

      var othersInCart = 0;

      var needs_change = 0;
      var needs_change_update = 0;

      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id == giftId) {
          giftQty += cart.items[i].quantity;
        } else if (cart.items[i].id == bookId) {
          bookQty += cart.items[i].quantity;
        } else if (cart.items[i].id == bookGiftId) {
          bookGiftQty += cart.items[i].quantity;
        } else if (cart.items[i].id == callId) {
          callQty += cart.items[i].quantity;
        } else {
          othersInCart += cart.items[i].quantity;
        }
      }

      var updates = {};

      var needsChange = 0;

      if (cart.items_subtotal_price > 6999) {
        updates[giftId] = 1;

        if (bookQty == 0) {
          updates[bookGiftId] = 1;
          // Checking for update
          if (giftQty == 1 && bookGiftQty == 1) {
            needsChange = 0;
          } else {
            needsChange = 1;
          }
        } else {
          updates[bookGiftId] = 1;
          updates[bookId] = 0;

          // Checking for update
          if (giftQty == 1 && bookGiftQty == 1) {
            needsChange = 0;
          } else {
            needsChange = 1;
          }
        }
      } else {
        updates[giftId] = 0;
        // Kai  1 produktas
        if (cart.item_count == 1) {
          console.log("line344");
          // Kai nera knygos
          if (bookQty == 0) {
            if (bookGiftQty == 0) {
              updates[bookGiftId] = 1;
              needsChange = 1;
            } else {
              // Kai tik dovana carte
              updates[bookGiftId] = 0;
              needsChange = 1;
            }
          }
          // Kai yra knyga
          else {
          }
        } else if (cart.item_count > 1) {
          console.log("line362");
          if (bookQty == 0) {
            console.log("line344");

            updates[bookGiftId] = 1;

            if (bookGiftQty != 1) {
              needsChange = 1;
            }
          }
          // Kai yra knyga
          else {
            updates[bookGiftId] = 1;
            updates[bookId] = 0;
            meedsCHange = 1;
          }

          // Kai yra tik dovanos:
          if (cart.item_count == 2) {
            if (bookGiftQty > 0 && giftQty > 0) {
              updates[bookGiftId] = 0;
              updates[giftId] = 0;
              meedsCHange = 1;
            }
          }
        } else {
          console.log("line382");
          updates[bookGiftId] = 0;
          if (bookGiftQty != 0) {
            needsChange = 1;
          }
        }

        if (giftQty != 0) {
          needsChange = 1;
        }
      }

      console.log(needsChange, "NEEDS CHANGE");
      console.log(updates, "updates data");
      console.log(
        "knyga:",
        bookQty,
        "knyga dovana: ",
        bookGiftQty,
        "dovana: ",
        giftQty
      );
      if (needsChange == 1) {
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: {
            updates: updates,
          },
          success: function (data) {
            // window.location.reload();
          },
        });
      }

      // console.log(needs_change, 'NEEDS CHANGE IDENTIFICATOR');

      // console.log(needs_change_update);

      // if (needs_change_update == 1){
      //   $.ajax({
      //       type: 'POST',
      //       url: '/cart/update.js',
      //       data: {
      //           updates: updates
      //       },
      //       dataType: 'json'
      //   });
      // }
      // if (needs_change == 1){
      //   if (giftQty > 0) {
      //     jQuery.ajax({
      //       type: "POST",
      //       url: "/cart/change.js",
      //       data: data,
      //       dataType: "json",
      //       success: function() {
      //           console.log("Changed Gift Quantity");
      //           // If tracking is allowed and the request was successful,
      //           // you may trigger your tracking events here if needed.
      //       }
      //     });
      //   } else {
      //     jQuery.ajax({
      //       type: "POST",
      //       url: "/cart/add.js",
      //       data: data,
      //       dataType: "json",
      //       success: function () {
      //         console.log("Added Gift Quantity");
      //       },
      //     });
      //   }
      // }
    }
  });
}

$(document).on("click", ".nr_cart_sub_upsell", function () {
  $(this).addClass("active");
  $(this).find(".nr_cart_sub_headline").html("Upgrading...");

  var mode = $(this).attr("data");
  if (mode == "higher") {
    var variant1 = 45054881595569; // Variant ID 1 (to be removed)
    var variant2 = 45054887526577; // Variant ID 2 (to be added with selling plan)
    var selling_plan = 1969258673; // Selling plan ID for variant2
  } else {
    var variant1 = 44836507189425; // Variant ID 1 (to be removed)
    var variant2 = 42855263502513; // Variant ID 2 (to be added with selling plan)
    var selling_plan = 1313734833; // Selling plan ID for variant2
  }

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: variant2, // Variant ID to add
      quantity: 1, // Quantity of the variant to add
      selling_plan: selling_plan, // Attach the selling plan
    },
    dataType: "json", // Ensure JSON encoding
    success: function (data) {
      console.log("Add success:", data);

      // Now, remove the original item
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: {
          updates: {
            [variant1]: 0, // Set quantity to 0 to remove it
          },
        },
        success: function (data) {
          console.log("Remove success:", data);
          buildCart(); // Rebuild the cart to reflect changes
        },
        error: function (xhr, status, error) {
          console.error("Error removing item from cart:", xhr.responseText);
        },
      });
    },
    error: function (xhr, status, error) {
      console.error("Error adding item to cart:", xhr.responseText);
    },
  });

  // Remove the first item (if it's in the cart)
  // $.ajax({
  //     type: 'POST',
  //     url: '/cart/update.js',
  //     data: {
  //         updates: {
  //             [variant1]: 0 // Set quantity to 0 to remove it
  //         }
  //     },
  //     success: function(data) {
  //         // Now, add the second item with the selling plan
  //         $.ajax({
  //             type: 'POST',
  //             url: '/cart/add.js',
  //             data: {
  //                 id: variant2,          // Variant ID to add
  //                 quantity: 1,            // Quantity of the variant to add
  //                 selling_plan: selling_plan // Attach the selling plan
  //             },
  //             dataType: 'json', // Ensure JSON encoding
  //             success: function(data) {
  //               console.log("Add success:", data);
  //                 buildCart(); // Rebuild the cart to reflect changes
  //             },
  //             error: function(xhr, status, error) {
  //                 console.error("Error adding item to cart:", xhr.responseText);
  //             }
  //         });
  //     },
  //     error: function(xhr, status, error) {
  //         console.error("Error removing item from cart:", xhr.responseText);
  //     }
  // });
});

function buildCart() {
  setTimeout(function () {
    var cart_item = [];
    var summary_item = [];
    jQuery.getJSON("/cart.js", function (cart) {
      console.log(cart);

      var compare_price_integer = 0;
      // var currency = "$";
      var currency = $(".nr_cart_checkout_btn")
        .attr("data-cur")
        .replace("0,00", "")
        .replace("0.00", "");
      var discounts = 0;

      // cart summary variables
      var kamstukai = 0;
      var dovana = 0;

      var list300 = 0;

      var list300id = 9196256428355;
      var kamstukaiId = "kamstukai";
      var kamstukaiId2 = "miegui";
      var dovanaId = "dovana";

      // For story upsells
      var upsellId = 47268422779203;
      var upsellQty = 0;

      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].handle).indexOf(kamstukaiId) != -1) {
          kamstukai = kamstukai + cart.items[i].quantity;
        }
        if (String(cart.items[i].handle).indexOf(kamstukaiId2) != -1) {
          kamstukai = kamstukai + cart.items[i].quantity;
        }

        if (String(cart.items[i].handle).indexOf(dovanaId) != -1) {
          dovana = dovana + cart.items[i].quantity;
        }

        if (cart.items[i].product_id == list300id) {
          list300 = 1;
        }

        // For story upsells
        if (cart.items[i].id == upsellId) {
          upsellQty = 1;
        }
      }

      for (var i = 0; i < cart.items.length; i++) {
        const currItem = cart.items[i];
        var quantity = currItem.quantity;
        var price = ((currItem.price * quantity) / 100).toFixed(2);
        var compare_price = "";

        // Price check
        $(".All_product_selector__js").each(function () {
          if ($(this).attr("data-id") == currItem.id) {
            compare_price = $(this).attr("data-compare-price");
          }
        });
        compare_price = ((compare_price * quantity) / 100).toFixed(2);
        compare_price = parseFloat(compare_price);
        compare_price_integer = compare_price_integer + compare_price;

        compare_price = compare_price.toFixed(2);

        if (compare_price != "0.00") {
          console.log("420");
          if (currItem.final_price == currItem.original_price) {
            console.log("422");
            if (isNaN(compare_price)) {
              var price_line = currency + price + " ";
            } else {
              console.log("426");
              var discountPerc = Math.round(
                ((parseFloat(compare_price) - parseFloat(price)) * 100) /
                  parseFloat(compare_price)
              );
              var price_line =
                currency +
                price +
                " " +
                "<s>" +
                currency +
                compare_price +
                " " +
                "</s> ";

              price_integer = quantity * currItem.final_price;
            }
          } else if (currItem.final_price < currItem.original_price) {
            console.log("435");
            price = (currItem.final_line_price / 100).toFixed(2);
            var discountPerc = Math.round(
              ((parseFloat(compare_price) - parseFloat(price)) * 100) /
                parseFloat(compare_price)
            );
            var price_line =
              currency +
              price +
              " " +
              "<s>" +
              currency +
              compare_price +
              " " +
              "</s> ";

            price_integer = quantity * currItem.final_price;
          }
        } else {
          console.log("440");
          if (currItem.final_price == currItem.original_price) {
            var price_line = currency + price + " ";
            console.log("446");
            price_integer = quantity * currItem.final_price;
            compare_price_integer =
              compare_price_integer + currItem.original_line_price / 100;
          } else if (currItem.final_price < currItem.original_price) {
            console.log("451");
            price = (currItem.final_line_price / 100).toFixed(2);
            var discountPerc = Math.round(
              ((parseFloat(compare_price) - parseFloat(price)) * 100) /
                parseFloat(compare_price)
            );
            var price_line =
              currency +
              price +
              " " +
              "<s>" +
              currency +
              (currItem.original_line_price / 100).toFixed(2) +
              " " +
              "</s> ";

            price_integer = quantity * currItem.final_price;
            compare_price_integer =
              compare_price_integer + currItem.original_line_price / 100;
          }
        }

        // Variant Title check
        var variant_option1 = currItem.variant_options[0];
        var variant_option2 = currItem.variant_options[1];
        var variant_selling_plan = currItem.selling_plan_allocation
          ? " | " + currItem.selling_plan_allocation.selling_plan.name
          : "";

        if (
          variant_option1 == "Default Title" ||
          typeof variant_option1 == "undefined"
        ) {
          var cart_option1_line = "";
        } else {
          var cart_option1_line =
            '<p class="nr_cart_item_variant">' +
            variant_option1 +
            variant_selling_plan +
            "</p>";
        }

        if (
          variant_option2 == "Default Title" ||
          typeof variant_option2 == "undefined"
        ) {
          var cart_option2_line = "";
        } else {
          var cart_option2_line =
            '<p class="nr_cart_item_variant"><span>' +
            variant_option2 +
            "</span></p>";
        }

        var item_title = currItem.product_title.replace(
          " - garsą izoliuojantys ausų kamštukai",
          ""
        );

        if (currItem.product_id == "8181395357873") {
        } else if (currItem.id == "44836507189425") {
          cart_item[i] =
            `<div class="nr_cart_item_outer">
                  <div class="nr_cart_item" data-id="` +
            currItem.id +
            `">
                      <div>
                          <img src="` +
            currItem.image +
            `">
                      </div>
                      <div>
                          <p class="nr_cart_item_title">` +
            item_title +
            `</p>
                          ` +
            cart_option1_line +
            `
                          ` +
            cart_option2_line +
            `
                          
                          <div class="nr_cart_item_quantity_cont">
                              <div class="nr_cart_quantity_minus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg></div>
                              <div class="nr_cart_quantity_value">` +
            currItem.quantity +
            `</div>
                              <div class="nr_cart_quantity_plus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg></div>
                          </div>
                      </div>
                      <div>
                         <p class="nr_cart_item_price">` +
            price_line +
            `</p>
                          <div class="nr_cart_item_remove">
                              <img src="https://cdn.shopify.com/s/files/1/0898/2501/8136/files/Untitled_design_7_1.png?v=1732272564">
                              <span class="loader"></span>                  
                          </div>
                      </div>
                    </div>
                    <div class="nr_cart_sub_upsell">
                        <p class="nr_cart_sub_upsell_title">79% of our users choose subscription</p>
                        <div class="nr_cart_sub_checkbox">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                            </div>
                            <div>
                                <p class="nr_cart_sub_headline">Upgrade to Subscription & <span>Save 25%</span> per purchase!</p>
                            </div>
                        </div>
                        <img class="nr_cart_sub_icons" src="https://cdn.shopify.com/s/files/1/0585/4910/8913/files/icns.png?v=1732710878">
                    </div>
                </div>
            `;
        }
        // Price testing higher
        else if (currItem.id == "45054881595569") {
          cart_item[i] =
            `<div class="nr_cart_item_outer">
                  <div class="nr_cart_item" data-id="` +
            currItem.id +
            `">
                      <div>
                          <img src="` +
            currItem.image +
            `">
                      </div>
                      <div>
                          <p class="nr_cart_item_title">` +
            item_title +
            `</p>
                          ` +
            cart_option1_line +
            `
                          ` +
            cart_option2_line +
            `
                          
                          <div class="nr_cart_item_quantity_cont">
                              <div class="nr_cart_quantity_minus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg></div>
                              <div class="nr_cart_quantity_value">` +
            currItem.quantity +
            `</div>
                              <div class="nr_cart_quantity_plus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg></div>
                          </div>
                      </div>
                      <div>
                         <p class="nr_cart_item_price">` +
            price_line +
            `</p>
                          <div class="nr_cart_item_remove">
                              <img src="https://cdn.shopify.com/s/files/1/0898/2501/8136/files/Untitled_design_7_1.png?v=1732272564">
                              <span class="loader"></span>                  
                          </div>
                      </div>
                    </div>
                    <div class="nr_cart_sub_upsell" data="higher">
                        <p class="nr_cart_sub_upsell_title">79% of our users choose subscription</p>
                        <div class="nr_cart_sub_checkbox">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                            </div>
                            <div>
                                <p class="nr_cart_sub_headline">Upgrade to Subscription & <span>Save 25%</span> per purchase!</p>
                            </div>
                        </div>
                        <img class="nr_cart_sub_icons" src="https://cdn.shopify.com/s/files/1/0585/4910/8913/files/icns.png?v=1732710878">
                    </div>
                </div>
            `;
        } else if (
          currItem.id == "44969780805809" ||
          currItem.id == "45054879105201" ||
          currItem.id == "45193441378481" ||
          currItem.id == "44652185092273"
        ) {
          cart_item[i] =
            `<div class="nr_cart_item_outer" >
                  <div class="nr_cart_item" data-id="` +
            currItem.id +
            `">
                      <div>
                          <img src="` +
            currItem.image +
            `">
                      </div>
                      <div>
                          <p class="nr_cart_item_title">` +
            item_title +
            `</p>
                          ` +
            cart_option1_line +
            `
                          ` +
            cart_option2_line +
            `
                          
                         <div class="nr_cart_item_quantity_cont" style="text-align: center; max-width: 50px; justify-content: center;">
                              
                              <div class="nr_cart_quantity_value">` +
            currItem.quantity +
            `</div>
                              
                          </div>
                      </div>
                      <div>
                         <p class="nr_cart_item_price">` +
            price_line +
            `</p>
                          <div class="nr_cart_item_remove">
                              <img src="https://cdn.shopify.com/s/files/1/0898/2501/8136/files/Untitled_design_7_1.png?v=1732272564">
                              <span class="loader"></span>                  
                          </div>
                      </div>
                    </div>
                    
                </div>
            `;
        } else {
          cart_item[i] =
            `
                  <div class="nr_cart_item" data-id="` +
            currItem.id +
            `">
                      <div>
                          <img src="` +
            currItem.image +
            `">
                      </div>
                      <div>
                          <p class="nr_cart_item_title">` +
            item_title +
            `</p>
                          ` +
            cart_option1_line +
            `
                          ` +
            cart_option2_line +
            `
                          
                          <div class="nr_cart_item_quantity_cont">
                              <div class="nr_cart_quantity_minus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg></div>
                              <div class="nr_cart_quantity_value">` +
            currItem.quantity +
            `</div>
                              <div class="nr_cart_quantity_plus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg></div>
                          </div>
                      </div>
                      <div>
                         <p class="nr_cart_item_price">` +
            price_line +
            `</p>
                          <div class="nr_cart_item_remove">
                              <img src="https://cdn.shopify.com/s/files/1/0898/2501/8136/files/Untitled_design_7_1.png?v=1732272564">
                              <span class="loader"></span>                  
                          </div>
                      </div>
                    </div>
                        `;
        }
      }

      if (cart.item_count == 0) {
        $("cart-drawer-content").hide();
        $(".nr_cart_progress").hide();
        $(".nr_cart_footer").hide();
        $(".cart-count-bubble").hide();
        $(".nr_cart_empty").show();
        $(".nr_cart_reserved").hide();
        $(".nr_cart_units span").html("0");
      } else if (cart.item_count >= 1) {
        // For story upsells

        // if (upsellQty == 1){
        //   setTimeout(function(){
        //     $('.nr_cart_story_upsells').hide();
        //   },100);

        // }

        setTimeout(function () {
          console.log("Here testing =====================");
          $(".nr_cart_story_upsells").each(function () {
            var currentId = $(this).attr("data-id");

            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].id == currentId) {
                $(this).hide();
              }
            }
          });
        }, 100);

        $(".nr_cart_empty").hide();
        $(".nr_cart_reserved").show();
        $(".cart-count-bubble span").text(cart.item_count);
        $(".cart-count-bubble").show();
        $("cart-drawer-content").show();
        $(".nr_cart_footer").show();
        $(".nr_cart_progress").show();
        $(".nr_cart_drawer_content__js").html(cart_item);
        if (cart.item_count == 1) {
          $(".nr_cart_units span").html(cart.item_count);
        } else {
          $(".nr_cart_units span").html(cart.item_count);
        }

        var cart_total = cart.total_price;

        var youSave = (compare_price_integer - cart_total / 100).toFixed(2);
        console.log(youSave, "HOW MUCH YOU SAVE");
        if (cart_total / 100 == compare_price_integer) {
          setTimeout(function () {
            $(".subtotal .nr_cart_summary_prices s").hide();
            $(".nr_cart_total .nr_cart_summary_prices s").hide();
            $(".nr_cart_summary_line.nr_save").hide();
          }, 50);
        } else {
          setTimeout(function () {
            $(".nr_cart_summary_line.nr_save").css("display", "flex");
            $(".nr_save_price").html(currency + youSave);
          }, 50);
        }
        var cart_total_sub = (cart_total / 100).toFixed(2);
        var compare_price_integer_sub = (compare_price_integer - 19.99).toFixed(
          2
        );

        // Shipping
        if (cart_total > 3000) {
          $(
            '.nr_cart_summary_line[data="shipping"] .nr_cart_summary_prices'
          ).html("0.00 €<s>0 €</s>");
        } else {
          $(
            '.nr_cart_summary_line[data="shipping"] .nr_cart_summary_prices'
          ).html("0 €");
          cart_total = cart_total + 0;
        }
        var cart_total_int = cart_total;
        cart_total = (cart_total / 100).toFixed(2);
        compare_price_integer = compare_price_integer + 0;
        compare_price_integer = compare_price_integer.toFixed(2);

        $(".nr_cart_summary_line.subtotal .nr_cart_summary_prices").html(
          currency +
            cart_total_sub +
            " " +
            " <s>" +
            currency +
            compare_price_integer_sub +
            " " +
            "</s>"
        );
        $(".nr_cart_summary_line.nr_cart_total .nr_cart_summary_prices").html(
          currency +
            cart_total +
            " " +
            " <s>" +
            currency +
            compare_price_integer +
            " " +
            "</s>"
        );

        $(".nr_cart_checkout_price").html(currency + cart_total);

        $(".nr_cart_upsell_only_pillow").hide();

        $('.nr_cart_summary_line[data="dovana"]').hide();

        if (dovana > 0) {
          $('.cart_summary_items__js .nr_cart_summary_line[data="dovana"]').css(
            "display",
            "flex"
          );
          $('.cart_summary_items__js .nr_cart_summary_line[data="dovana"]')
            .find(".nr_cart_summary_line__qty")
            .html(dovana);
        }

        // Progress calculation and upsells logic
        cartUpsellsAndProgress(cart_total_int);
      }

      $(".cd_upsells_carousel").slick("refresh");
      setTimeout(function () {
        $(".cd_upsells_out").addClass("active");
      }, 300);
    });
  }, 1000);
}

buildCart();

$(document).on("click", ".nr_cart_quantity_plus", function () {
  $(this).closest(".nr_cart_item").addClass("loading");

  var data_id = $(this).closest(".nr_cart_item").attr("data-id");
  var data_qty = parseFloat(
    $(this).closest(".nr_cart_item").find(".nr_cart_quantity_value").html()
  );

  data_qty++;

  var data = {
    id: data_id,
    quantity: data_qty,
  };

  console.log(data, "   data");
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: data,
    dataType: "json",
    success: function () {
      console.log(data);
      buildCart();
      setTimeout(function () {
        $(".nr_cart_item").removeClass("loading");
      }, 1500);
    },
  });
});

$(document).on("click", ".nr_cart_quantity_minus", function () {
  $(this).closest(".nr_cart_item").addClass("loading");

  var data_id = $(this).closest(".nr_cart_item").attr("data-id");
  var data_qty = parseFloat(
    $(this).closest(".nr_cart_item").find(".nr_cart_quantity_value").html()
  );

  data_qty--;

  var data = {
    id: data_id,
    quantity: data_qty,
  };

  console.log(data, "   data");
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: data,
    dataType: "json",
    success: function () {
      console.log(data);
      buildCart();
      setTimeout(function () {
        $(".nr_cart_item").removeClass("loading");
      }, 1500);
    },
  });
});

$(document).on("click", ".nr_cart_item_remove", function () {
  $(this).closest(".nr_cart_item").addClass("loading");

  // jQuery.ajax({
  //     type: "POST",
  //     url: "/cart/clear.js",
  //     dataType: "json",
  //     success: function() {
  //         buildCart();
  //     }
  // });

  var data_id = $(this).closest(".nr_cart_item").attr("data-id");
  var data_qty = 0;

  var data = {
    id: data_id,
    quantity: data_qty,
  };

  console.log(data, "   data");
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: data,
    dataType: "json",
    success: function () {
      console.log(data);
      buildCart();
      setTimeout(function () {
        $(".nr_cart_item").removeClass("loading");
      }, 1500);
    },
  });
});

$(".header__icon--cart").click(function (evt) {
  evt.preventDefault();

  $(".nr_cart_drawer_outer").css("display", "flex");

  setTimeout(function () {
    $(".nr_cart_drawer_outer").addClass("active");
    $("body").addClass("Overflow_hidden");
    $("body").addClass("overflow-hidden");
    $(".cd_upsells_carousel").slick("refresh");
    // $('.nr_Cart_up_car').slick('refresh');
  }, 100);
});

$(".nr_cart_goback").click(function () {
  $(".nr_cart_drawer_outer").removeClass("active");

  setTimeout(function () {
    $(".nr_cart_drawer_outer").hide();
    $("body").removeClass("Overflow_hidden");
    $("body").removeClass("overflow-hidden");
    // $('.nr_Cart_up_car').slick('refresh');
  }, 300);
});

$(".nr_cart_drawer_outer").click(function () {
  if (!$(event.target).closest(".nr_cart_drawer").length) {
    $(".nr_cart_drawer_outer").removeClass("active");

    setTimeout(function () {
      $(".nr_cart_drawer_outer").hide();
      $("body").removeClass("Overflow_hidden");
      $("body").removeClass("overflow-hidden");
      // $('.nr_Cart_up_car').slick('refresh');
    }, 300);
  }
});

$(".Product_atc_button").click(function () {
  if ($(this).attr("data-stock") == "1") {
    addClassicItem();
  }
});

$(document).on("click", ".nrcs_checking", function () {
  $(this).toggleClass("disabled");
  $(".Slide_cart_summary").addClass("loading");
  setTimeout(function () {
    $(".Slide_cart_summary").removeClass("loading");
  }, 1500);
});

// function initProtection() {
//   jQuery.getJSON("/cart.js", function (cart) {

//     var data_id = $('.nr_cart_shipping_prot').attr('data-id');
//     var data_qty = 0;

//     for (var i = 0; i < cart.items.length; i++) {
//       if (cart.items[i].id == data_id) {
//         data_qty += cart.items[i].quantity;
//       }
//     }

//     if (cart.item_count > 0) {
//       if ($('.nrcs_checking').hasClass('disabled')) {
//         if (data_qty > 0) {
//           // var data = {
//           //   id: data_id,
//           //   quantity: 0
//           // };
//           // var updates = {
//           //     data_id: 0
//           // };
//           setTimeout(function () {
//               var updates = {};
//               updates[data_id] = 0;

//               $.ajax({
//                   type: 'POST',
//                   url: '/cart/update.js',
//                   data: {
//                       updates: updates
//                   },
//                   dataType: 'json',
//                   async: false,
//                   success: function () {
//                       buildCart();
//                   },
//               });
//           },100);

//           // jQuery.ajax({
//           //   type: "POST",
//           //   url: "/cart/change.js",
//           //   data: data,
//           //   dataType: "json",
//           //   success: function () {
//           //     buildCart();
//           //   },
//           // });
//         }
//       }
//       else {
//         if (data_qty == 0) {
//           // var data = {
//           //   id: data_id,
//           //   quantity: 1
//           // };

//           // jQuery.ajax({
//           //   type: "POST",
//           //   url: "/cart/add.js",
//           //   data: data,
//           //   dataType: "json",
//           //   success: function () {
//           //     buildCart();
//           //   },
//           // });
//           // var updates = {
//           //     data_id: 1
//           // };
//           setTimeout(function () {
//               var updates = {};
//               updates[data_id] = 1;

//               $.ajax({
//                   type: 'POST',
//                   url: '/cart/update.js',
//                   data: {
//                       updates: updates
//                   },
//                   dataType: 'json',
//                   async: false,
//                   success: function () {
//                       buildCart();
//                   },
//               });
//           },100);

//         }
//       }
//     }

//   });
// }

function initProtection() {
  jQuery.getJSON("/cart.js", function (cart) {
    var data_id = $(".nr_cart_shipping_prot").attr("data-id");
    var data_qty = 0;

    var otherItemsInCart = 0;

    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].id == data_id) {
        data_qty += cart.items[i].quantity;
      } else {
        otherItemsInCart += cart.items[i].quantity;
      }
    }

    console.log(data_qty, "SHIPPING PROTECTION", otherItemsInCart);

    if (cart.item_count > 0) {
      if (otherItemsInCart < 1 && data_qty > 0) {
        var data = {
          id: data_id,
          quantity: 0,
        };

        $(".nr_cart_shipping_prot").addClass("loading");

        jQuery.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: data,
          dataType: "json",
          success: function () {
            buildCart();
          },
        });
      }
      if ($(".nrcs_checking").hasClass("disabled")) {
        if (data_qty > 0) {
          var data = {
            id: data_id,
            quantity: 0,
          };

          $(".nr_cart_shipping_prot").addClass("loading");

          jQuery.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: data,
            dataType: "json",
            success: function () {
              buildCart();
            },
          });
        }
      } else {
        if (data_qty == 0) {
          // var data = {
          //   id: data_id,
          //   quantity: 1
          // };

          var updates = {};
          updates[data_id] = 1;

          $(".nr_cart_shipping_prot").addClass("loading");

          $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: {
              updates: updates,
            },
            success: function (data) {
              buildCart();
            },
          });

          // jQuery.ajax({
          //   type: "POST",
          //   url: "/cart/add.js",
          //   data: data,
          //   dataType: "json",
          //   success: function () {
          //      buildCart();
          //   },
          // });
        }
      }
    }
  });
}

function toggleSwitchDefault() {
  var position = $(".nr_cart_shipping_prot").attr("data-protection");
  // console.log(position);
  if (position == "1") {
  } else {
    $(".nrcs_checking").addClass("disabled");
  }
}

// setInterval(function () {
//   toggleSwitchDefault()
// }, 50);

// setInterval(function () {
//   initProtection();
// }, 1000);

$(".cd_upsells_carousel").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  prevArrow:
    "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_4635.png?v=1732704079'/></button>",
  nextArrow:
    "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_4635.png?v=1732704079'/></button>",
});

$(document).on("click", ".cd_atc_ox", function (evt) {
  evt.preventDefault();

  var currentId = $(this).attr("data-id");
  var currentQty = 1;
  var items = [];
  items.push({ id: currentId, quantity: currentQty });

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      items: items,
    },
    dataType: "json",
    success: function (data) {
      buildCart();
    },
    error: function () {
      alert("Error adding the items to the cart.");
    },
  });
});

function addClassicItem() {
  $(".Product_atc_button").text("Įdedama...");
  var currentDeliveryDate = $(".delivery-hidden").attr("value");
  var currentQty = $(".quantity__input").val();
  var currentId = $(".product-variant-id").attr("value");
  var currentTitle = $(".product-variant-id").attr("data-title-main");
  var currentImage = $(".product-variant-id")
    .attr("data-img")
    .replace("http://127.0.0.1:9292", "https://noreo-lt.myshopify.com")
    .replace("//noreo.lt", "https://noreo-lt.myshopify.com");
  var currentProductId = $(".product-variant-id").attr("data-product-id");
  var currentUrl = window.location.href;

  var data_klaviyo = {
    ProductId: currentProductId,
    Name: currentTitle,
    ImageUrl: currentImage,
    items: {
      id: currentId,
      quantity: currentQty,
      variant_id: currentId,
      title: currentTitle,
      product_id: currentProductId,
      image: currentImage,
    },
    URL: currentUrl,
  };

  var data = {
    id: currentId,
    quantity: currentQty,
  };
  console.log(data);

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      console.log(data);
      buildCart();
      gtag("event", "Clicked ATC", {
        event_label: "Clicked ATC Button",
        event_value: "Added To Cart",
      });
      console.log("Google analytics Added To Cart Event Triggered");
      _learnq.push(["track", "Added to Cart", data_klaviyo]);
      console.log(data_klaviyo, "Klaviyo event sent");
      setTimeout(function () {
        $(".Product_atc_button").text("Įdėti į krepšelį");
      }, 1000);

      $("body").addClass("Overflow_hidden");
      $("body").addClass("overflow-hidden");
      // $('.nr_Cart_up_car').slick('refresh');
      $(".nr_cart_drawer_outer").css("display", "flex");

      setTimeout(function () {
        $(".nr_cart_drawer_outer").addClass("active");
      }, 100);
    },
  });
}

function cartUpsellsAndProgress(cart_total_int) {
  var message = "";
  var upsell_message = "";
  var upsells_headline = "";
  var percent = 0;

  console.log(cart_total_int, "cart total");
  if (cart_total_int < 10) {
    var lieka = 7500 - cart_total_int;

    percent = (cart_total_int * 100) / 7500;
    lieka = (lieka / 100).toFixed(2);
    message = "Add products for $" + lieka + " more and get a FREE SHIPPING!";
  } else {
    percent = 100;
    message = "You’ve unlocked <span>FREE shipping</span> on your order today!";
  }
  $(".nr_cart_progress").find("p").html(message);
  $(".nr_cart_progress_inner").css("width", percent + "%");
  $(".nr_pillow_upsell_message__js").html(upsell_message);
  $(".nr_cart_upsell_label p").html(upsells_headline);
  console.log(upsells_headline);
}

$(".nr_cart_checkout_btn").click(function () {
  window.location.href = "/checkout";
});

var countDownDate = new Date();
countDownDate.setMinutes(countDownDate.getMinutes() + 15); // Set countdown to 15 minutes from now

var x = setInterval(function () {
  var now = new Date().getTime();
  var distance = countDownDate - now;

  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  $(".hours").text(hours);
  $(".nr_cart_timer__min").text(minutes);
  $(".nr_cart_timer__sek").text(seconds);

  if (distance < 0) {
    clearInterval(x);
    $(".hours").text("0");
    $(".nr_cart_timer__min").text("0");
    $(".nr_cart_timer__sek").text("0");
    $(".nr_cart_timer p").text("Time is out!");
  }
}, 1000);

$(".Slide_cart_agree_line").click(function () {
  $(this).toggleClass("active");
});

$(document).on("click", ".cb_atc_btn", function (evt) {
  evt.preventDefault();
  var dataId = $(this).attr("data-id");
  var qty = 1;

  var data = {
    id: dataId,
    quantity: qty,
  };
  console.log(data);

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      buildCart();
      setTimeout(function () {
        $(".nr_cart_drawer_outer").css("display", "flex");
        setTimeout(function () {
          $(".nr_cart_drawer_outer").addClass("active");
        }, 100);
      }, 1000);
    },
  });
});

$(document).on("click", ".nr_cart_story_upsells", function () {
  $(this).find(".nr_cart_story_checkbox").toggleClass("active");
  if ($(this).find(".nr_cart_story_checkbox").hasClass("active")) {
    var variantId = $(this).attr("data-id");
    addStoryUpsell(variantId);
  }
});

function addStoryUpsell(variantId) {
  var upsellId = variantId;
  var upsellQty = 1;

  var data = {
    id: upsellId,
    quantity: upsellQty,
  };
  console.log(data);

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      buildCart();
    },
  });
}

// --------------- PDP Section Upsell --------------------------------
$(document).on("click", ".pdp-upsell__add-button", function () {
  var variantId = $(this).attr("data-variant-id");
  addUpsellToCart(variantId);
});
function addUpsellToCart(variantId) {
  const id = variantId;
  $.post("/cart/add.js", { items: [{ id, quantity: 1 }] })
    .done(() => {
      buildCart();
      openSlideCart();
    })
    .fail(() => console.error("Error adding item to cart:", error));
}

// ---------------- Export --------------------------------------
function openSlideCart() {
  $(".nr_cart_drawer_outer").css("display", "flex");
  setTimeout(function () {
    $("body").addClass("Overflow_hidden");
    $("body").addClass("overflow-hidden");
    $(".nr_cart_drawer_outer").addClass("active");
    $(".cd_upsells_carousel").slick("refresh");
  }, 100);
}

function closeSlideCart() {
  $(".nr_cart_drawer_outer").removeClass("active");
  setTimeout(function () {
    $(".nr_cart_drawer_outer").hide();
    $("body").removeClass("Overflow_hidden");
    $("body").removeClass("overflow-hidden");
  }, 300);
}
window.cart_open = openSlideCart;
window.cart_close = closeSlideCart;
window.cart_build = buildCart;
